import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";
import UtilService from "../../../services/UtilService";

export function wordWheelPlayerPlaysPath({ cloudUserId, sessionId, name } = {}) {
    const params = new URLSearchParams();
    if (cloudUserId) {
        params.set("cloudUserId", cloudUserId);
    } else if (sessionId) {
        params.set("sessionId", sessionId);
    } else {
        return "/admin/puzzle/word_wheel_play";
    }
    if (name) {
        params.set("player", name);
    }
    return `/admin/puzzle/word_wheel_play?${params.toString()}`;
}

function mapPlayRow(row) {
    const createdAtMs = Number(row.createdAt) || 0;
    const startedAtMs = Number(row.startedAt) || createdAtMs;
    const finishedAtMs = Number(row.finishedAt) || 0;
    const totalWords = row.wordWheelTpl?.wordsInUse
        ? row.wordWheelTpl.wordsInUse.split("\n").filter((w) => w.trim()).length
        : row.wordsTotal || 0;
    const foundWordsCount = row.wordsFound
        ? row.wordsFound.split("\n").filter((w) => w.trim()).length
        : 0;
    const percentage = totalWords > 0 ? Math.round((foundWordsCount / totalWords) * 100) : 0;
    const session = row.sessionId ? String(row.sessionId) : "";
    const rcId = [row.details?.revenueCatOriginalAppUserId, row.details?.revenueCatAppUserId]
        .map((value) => (value == null ? "" : String(value).trim()))
        .find(Boolean);
    const anonymousLabel = rcId
        ? `Anonymous (${rcId})`
        : session
            ? `Anonymous (${session})`
            : "Anonymous";
    return {
        ...row,
        createdAtMs,
        startedAtMs,
        finishedAtMs,
        name: row.cloudUser?.email || row.cloudUser?.firstName || anonymousLabel,
        wordWheelTitle: row.wordWheelTpl?.title || "",
        startedAt: startedAtMs ? UtilService.formatDate(startedAtMs) : "",
        finishedAt: finishedAtMs ? UtilService.formatDate(finishedAtMs) : "",
        percentage,
        foundWords: row.wordsFound,
    };
}

const AdminWordWheelPlayService = {
    fetchPuzzlePlays: async ({
        wordWheelTplId,
        keyword,
        pageModel,
        sort,
        isCompleted,
        onlyStarted = false,
        cloudUserId = "",
        sessionId = "",
    }) => {
        const params = {
            page: pageModel.page,
            pageSize: pageModel.pageSize,
            sort: sort.map((s) => `${s.field}:${s.sort}`).join(","),
        };
        if (wordWheelTplId) params.wordWheelTplId = wordWheelTplId;
        if (keyword) params.keyword = keyword;
        if (isCompleted !== null && isCompleted !== undefined) params.isCompleted = isCompleted;
        if (onlyStarted === true) params.onlyStarted = true;
        if (cloudUserId) params.cloudUserId = cloudUserId;
        if (sessionId) params.sessionId = sessionId;

        const result = await ApiService.getData("/v1/puzzle/wordwheel-play", params);
        return {
            rows: (result?.content || []).map(mapPlayRow),
            total: result.page?.totalElements ?? 0,
        };
    },

    requestPuzzlePlay: async (
        wordWheelTplId,
        keyword,
        pageModel,
        sort,
        setRows,
        setRowCount,
        isCompleted,
        onlyStarted = false,
        cloudUserId = "",
        sessionId = "",
    ) => {
        const { rows, total } = await AdminWordWheelPlayService.fetchPuzzlePlays({
            wordWheelTplId,
            keyword,
            pageModel,
            sort,
            isCompleted,
            onlyStarted,
            cloudUserId,
            sessionId,
        });
        setRows(rows);
        setRowCount(total);
    },

    deletePlays: async (ids) => {
        const result = await ApiService.deleteData("/v1/puzzle/wordwheel-play", { wordWheelPlayIds: ids });
        Logger.log(result);
        return result;
    },
};

export default AdminWordWheelPlayService;
